import React from "react";
var __jsx = React.createElement;
import stl from './UnsubscribeInterest.module.css';
import { useTranslation } from "@i18n";
import Button from "@/components/UiKit/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api__unsubscribeInterest } from "@/apis/customer/customer";
import Loader3d from "@/pages/checkout/finance-checkout/FreeFinanceComponents/Loader3d";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { trackEvents } from "@/common/events/events";
var UnsubscribeInterest = function UnsubscribeInterest() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var location = useLocation();
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  useEffect(function () {
    var searchParams = new URLSearchParams(location.search);
    if (!searchParams.has("user_uuid") || !searchParams.has("interest_id")) {
      navigate("/");
    }
    var user_uuid = searchParams.get("user_uuid");
    var interest_id = searchParams.get("interest_id");
    api__unsubscribeInterest({
      user_uuid: user_uuid,
      interest_id: parseInt(interest_id)
    }).then(function (res) {
      if (res === null) {
        setLoading(true);
        return;
      }
      if (isLoggedIn) {
        trackEvents('notification_whatsapp_unsubscribe', {
          uuid: user_uuid,
          user_id: "966".concat(user.phone_number.slice(1))
        });
      } else {
        trackEvents('notification_whatsapp_unsubscribe', {});
      }
      setLoading(false);
    })["catch"](function (err) {
      setLoading(true);
      console.log(err, 'err');
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loader3d, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    hideFooter: true
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.unsubscribeWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.unsubscribeIcon
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/images/whatsapp-icon-new.svg",
    alt: "unsubscribe"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.unsubscribeHeader
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.unsubscribeHeaderText
  }, t("تم إلغاء الإشتراك.", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.unsubscribeDescription
  }, t("تم إلغاء الإشتراك من خدمة الرسائل التسويقية من خلال الواتساب.", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return navigate("/");
    },
    type: "button",
    className: stl.unsubscribeButton
  }, t("الصفحة الرئيسية", {
    ns: "web_common"
  })))))));
};
export default UnsubscribeInterest;